import type { SVGProps } from "react";
export interface CctvOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CctvOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CctvOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.886 4.902c.2-.548.78-.847 1.333-.707l.11.034 9.505 3.46a1.62 1.62 0 0 1 .797 2.419l.099.036a2.126 2.126 0 0 1 1.334 2.515l-.064.208-1.014 2.785-.046.107a1.126 1.126 0 0 1-2.07-.876l.972-2.669-.633-.23-1.023 1.34A1.124 1.124 0 1 1 17.4 11.96l1.867-2.446-8.707-3.169-.106-.045a1.126 1.126 0 0 1-.567-1.397ZM.875 21v-3a1.125 1.125 0 0 1 2.25 0v.375h2.353c.367 0 .695-.23.821-.574l.42-1.149-1.524-.555a1.125 1.125 0 1 1 .77-2.114l5.168 1.881a1.126 1.126 0 0 1-.769 2.115l-1.53-.558-.42 1.153a3.13 3.13 0 0 1-2.936 2.05H3.125V21a1.125 1.125 0 1 1-2.25 0m1.33-18.795a1.125 1.125 0 0 1 1.506-.078l.085.078 18 18 .078.085a1.126 1.126 0 0 1-1.584 1.583l-.085-.078-5.388-5.387-10.02-3.648a4.125 4.125 0 0 1-2.464-5.286l.684-1.88q.129-.356.315-.672L2.205 3.795l-.078-.085a1.125 1.125 0 0 1 .078-1.505m2.241 6.038a1.876 1.876 0 0 0 1.12 2.403l5.485 1.995-6.017-6.017z"
      />
    </svg>
  );
}
